export default __webpack_public_path__ + "32cd78a4e7a4767f2a4af44874e8ddb3.png";